import Helper from "../d3-common"

export default function getDimensions(elementId) {     
    const dim = Helper.getMaxDimensions(elementId)
    const vizWitdh = dim.w
    const vizHeigth = dim.h

    const dimensions = {
        width: vizWitdh,
        height: vizHeigth,
        margin: {
            top: 20,
            right: 50,
            bottom: 20,
            left: 150
        },
        lineHeight: 40,
        lineHeightModel: 20
    }

    dimensions.boundedWidth =
        dimensions.width - dimensions.margin.left - dimensions.margin.right
    dimensions.boundedHeight =
        dimensions.height - dimensions.margin.top - dimensions.margin.bottom

    return dimensions
}